export enum ActionExpenses {
  'play_cv_video' = 'play_cv_video',
  'unlock_contact' = 'unlock_contact',
}
